module.exports = __webpack_public_path__ + "img/Technology.df8530eb.svg";